import axios from './axios'
import router from '@/router'
import store from '@/store'
export default {
    isWx() {
        let ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
            return true;
        } else {
            return false;
        }
    },
    // hack 更新微信标题
    setTitle(title) {
        var body = document.getElementsByTagName('body')[0];
        document.title = title;
        var iframe = document.createElement("iframe");
        iframe.style.display="none";
      function fn() {
            setTimeout(function () {
                iframe.removeEventListener('load', fn);
                document.body.removeChild(iframe);
            }, 0);
        }
        iframe.addEventListener('load', fn);
        document.body.appendChild(iframe);
    },
    // 设置微信分享参数
    wxShare(option) {
        wx.ready(function () {
            wx.updateAppMessageShareData(option);
            wx.updateTimelineShareData(option);
            wx.onMenuShareAppMessage(option);
            wx.onMenuShareWechat(option);
            wx.onMenuShareTimeline(option);
        })
    },
    hideShare(){
        wx.hideOptionMenu();
    },
    // 微信jdk初始化
    async wxInit(url) {
        let res = await axios.get(`/63333/api/auth/jsTicket?url=${url}`);
        let apiList=[
          'hideMenuItems',
          'updateAppMessageShareData',
          'updateTimelineShareData',
          'onMenuShareAppMessage',
          'onMenuShareWechat',
          'onMenuShareTimeline',
          'setBounceBackground',
          'chooseWXPay'
        ];
        if (res) {
            wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: res.data.appid, // 必填，公众号的唯一标识
                timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
                signature: res.data.signature, // 必填，签名，见附录1
                jsApiList: apiList// 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            });
            wx.ready(function () {
                wx.hideMenuItems({
                    menuList: [
                        'menuItem:editTag',
                        'menuItem:delete',
                        'menuItem:copyUrl',
                        'menuItem:originPage',
                        'menuItem:readMode',
                        'menuItem:openWithQQBrowser',
                        'menuItem:openWithSafari',
                        'menuItem:share:email',
                        'menuItem:share:brand'
                    ] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
                });

                Promise.resolve()
            })
        }
    },


    // “分享到朋友圈”及“分享到QQ空间”
    wxShareToMoment(data) {
        wx.ready(() => {
            wx.updateTimelineShareData({
                title: data.title, // 分享标题
                link: data.link, // 分享链接
                imgUrl: data.imgUrl, // 分享图标
                success: function () {
                    // 用户确认分享后执行的回调函数
                },
                cancel: function () {
                    // 用户取消分享后执行的回调函数
                }
            });
        })
    },
    // “分享给朋友”及“分享到QQ”
    wxShareToMessage(data) {
        wx.ready(() => {
            wx.updateAppMessageShareData({
                title: data.title, // 分享标题
                desc: data.desc, // 分享描述
                link: data.link, // 分享链接
                imgUrl: data.imgUrl, // 分享图标
                success: function () {
                    // 用户确认分享后执行的回调函数
                },
                cancel: function () {
                    // 用户取消分享后执行的回调函数
                }
            });
        });
    },
    // 微信支付
    wxPay(data,currType,oid,fid) {
        wx.chooseWXPay({
            "timestamp": data.timeStamp,
            "nonceStr": data.nonceStr,
            "package": data.package1,
            "signType": data.signType,
            "paySign": data.paySign,
            success: function (res) {
              if(currType=='foundationPay'){
                router.push('/success/'+oid+'/'+fid)
              };
            },
            fail:function(error){

            },
            cancel:function(){

            }
        });
    },

}



// WEBPACK FOOTER //
// ./src/api/wechat.js